import DataProvider from '@app/model/_common/DataProvider';

// HolidayCheck Airport Codes
export const AirportCodeHolidayCheck = {
	FRA: { name: "Frankfurt", country: "Germany" },
	MUC: { name: "Munich", country: "Germany" },
	DUS: { name: "Düsseldorf", country: "Germany" },
	HAM: { name: "Hamburg", country: "Germany" },
	STR: { name: "Stuttgart", country: "Germany" },
	HAJ: { name: "Hannover", country: "Germany" },
	CGN: { name: "Cologne/Bonn", country: "Germany" },
	BER: { name: "Berlin Brandenburg", country: "Germany" },
	NUE: { name: "Nuremberg", country: "Germany" },
	BRE: { name: "Bremen", country: "Germany" }
} as const;

// TravelSupermarket Airport Codes
export const AirportCodeTravelSupermarket = {
	MAN: { name: "Manchester", country: "United Kingdom" },
	LGW: { name: "London Gatwick", country: "United Kingdom" },
	BHX: { name: "Birmingham", country: "United Kingdom" },
	STN: { name: "London Stansted", country: "United Kingdom" },
	EDI: { name: "Edinburgh", country: "United Kingdom" },
	GLA: { name: "Glasgow", country: "United Kingdom" },
	NCL: { name: "Newcastle", country: "United Kingdom" },
	BRS: { name: "Bristol", country: "United Kingdom" },
	LBA: { name: "Leeds Bradford", country: "United Kingdom" },
	LTN: { name: "London Luton", country: "United Kingdom" }
} as const;

// TUI DE Airport Codes
export const AirportCodeTuiDe = {
	FRA: { name: "Frankfurt", country: "Germany" },
	MUC: { name: "Munich", country: "Germany" },
	DUS: { name: "Düsseldorf", country: "Germany" },
	HAM: { name: "Hamburg", country: "Germany" },
	STR: { name: "Stuttgart", country: "Germany" },
	HAJ: { name: "Hannover", country: "Germany" },
	CGN: { name: "Cologne/Bonn", country: "Germany" },
	BER: { name: "Berlin Brandenburg", country: "Germany" },
	NUE: { name: "Nuremberg", country: "Germany" },
	BRE: { name: "Bremen", country: "Germany" }
} as const;

// TUI UK Airport Codes
export const AirportCodeTuiUk = {
	MAN: { name: "Manchester", country: "United Kingdom" },
	LGW: { name: "London Gatwick", country: "United Kingdom" },
	BHX: { name: "Birmingham", country: "United Kingdom" },
	STN: { name: "London Stansted", country: "United Kingdom" },
	EDI: { name: "Edinburgh", country: "United Kingdom" },
	GLA: { name: "Glasgow", country: "United Kingdom" },
	NCL: { name: "Newcastle", country: "United Kingdom" },
	BRS: { name: "Bristol", country: "United Kingdom" },
	LBA: { name: "Leeds Bradford", country: "United Kingdom" },
	LTN: { name: "London Luton", country: "United Kingdom" }
} as const;

// Jet2 Airport Codes
export const AirportCodeJet2 = {
	MAN: { name: "Manchester", country: "United Kingdom" },
	LGW: { name: "London Gatwick", country: "United Kingdom" },
	BHX: { name: "Birmingham", country: "United Kingdom" },
	STN: { name: "London Stansted", country: "United Kingdom" },
	EDI: { name: "Edinburgh", country: "United Kingdom" },
	GLA: { name: "Glasgow", country: "United Kingdom" },
	NCL: { name: "Newcastle", country: "United Kingdom" },
	BRS: { name: "Bristol", country: "United Kingdom" },
	LBA: { name: "Leeds Bradford", country: "United Kingdom" },
	LTN: { name: "London Luton", country: "United Kingdom" }
} as const;

// Type definitions
export type AirportCodeHolidayCheckKey = keyof typeof AirportCodeHolidayCheck;
export type AirportCodeTravelSupermarketKey = keyof typeof AirportCodeTravelSupermarket;
export type AirportCodeTuiDeKey = keyof typeof AirportCodeTuiDe;
export type AirportCodeTuiUkKey = keyof typeof AirportCodeTuiUk;
export type AirportCodeJet2Key = keyof typeof AirportCodeJet2;
export type AirportCodeKey =
	AirportCodeHolidayCheckKey
	| AirportCodeTravelSupermarketKey
	| AirportCodeTuiDeKey
	| AirportCodeTuiUkKey
	| AirportCodeJet2Key;

export type AirportInfo = { name: string; country: string };

// Map of airport codes per provider
export const airportCodesPerProvider: Map<DataProvider, Record<string, AirportInfo>> = new Map([
	[DataProvider.HOLIDAYCHECK, AirportCodeHolidayCheck as Record<string, AirportInfo>],
	[DataProvider.TRAVELSUPERMARKET, AirportCodeTravelSupermarket as Record<string, AirportInfo>],
	[DataProvider.TUIDE, AirportCodeTuiDe as Record<string, AirportInfo>],
	[DataProvider.TUIUK, AirportCodeTuiUk as Record<string, AirportInfo>],
	[DataProvider.JET2, AirportCodeJet2 as Record<string, AirportInfo>],
]);

// Helper function to get airport codes for a specific provider
export const getAirportCodesForProvider = (provider: DataProvider): Record<string, AirportInfo> | undefined => {
	return airportCodesPerProvider.get(provider);
};

// Helper function to get all airport code keys for a specific provider
export const getAirportCodeKeysForProvider = (provider: DataProvider): string[] => {
	const codes = airportCodesPerProvider.get(provider);
	return codes ? Object.keys(codes) : [];
};
